import {
  CANAL_VENDA,
  CANAIS_VENDA_TODOS,
  CANAIS_VENDA_FIXOS
} from "@/utils/canais-venda";

export function normalizeCanaisVendaFromApi(canaisFromApi) {
  const fromApi = Array.isArray(canaisFromApi) ? canaisFromApi : [];
  if (!fromApi.length) {
    return [...CANAIS_VENDA_TODOS];
  }
  const lifegrowthSelected = fromApi.includes(CANAL_VENDA.LIFEGROWTH);
  return lifegrowthSelected ? [...CANAIS_VENDA_TODOS] : [...CANAIS_VENDA_FIXOS];
}

export function buildCanaisVendaPayload(selected) {
  const sel = Array.isArray(selected) ? selected : [];
  const payload = [...CANAIS_VENDA_FIXOS];
  if (sel.includes(CANAL_VENDA.LIFEGROWTH)) {
    payload.push(CANAL_VENDA.LIFEGROWTH);
  }
  return payload;
}
